import Cookies from "js-cookie";

export const redirectTagPaths = {
    useradd: { pathname: "/account/users" },
    "kuda-pay": { pathname: "/confirm-invoice-payment" },
};

export const isLogin = () => {
    if (Cookies.get("kudaAppToken")) {
        return true;
    }
    return false;
};

export const forceLogout = async () => {
    document.body.classList.add("tokenExpired");
    Cookies.remove("kudaAppToken");
    Cookies.remove("kudaClient");
    Cookies.remove("kudaAppImage");
    Cookies.remove("kudaAccount");
    Cookies.remove("kudaID");
    Cookies.remove("kudaNO");
    Cookies.remove("newAccount");
    localStorage.removeItem("kudaBeneficiaries");
    localStorage.removeItem("kudaRecents");
    localStorage.removeItem("kudaBalance");
    sessionStorage.removeItem("kudaAppToken");
    localStorage.removeItem("segmentViewDashboardFlag");
    setTimeout(()=>{
        Cookies.remove("kudaAppRefreshToken");
    },5000)
};
